import { render, staticRenderFns } from "./util-modal.html?vue&type=template&id=67c0ccc2&scoped=true&external"
import script from "./util-modal.js?vue&type=script&lang=js&external"
export * from "./util-modal.js?vue&type=script&lang=js&external"
import style0 from "./util-modal.scss?vue&type=style&index=0&id=67c0ccc2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0ccc2",
  null
  
)

export default component.exports